const getters = {
  token: state => state.user.token,
  userPermission: state => state.user.userPermission,
  userInfo: state => state.user.userInfo,
  contacts: state => state.app.contacts,
  socketStatus: state => state.app.socketStatus,
  backendTableHeight: state => state.backend.tableHeight,
  lastWorkSheetPath: state => state.user.lastWorkSheetPath,
  unreadMessageCount: state => state.user.unreadMessageCount,
  projectPermission: state => state.app.projectPermission.data,
  mode: state => state.user.mode,
  location: state => state.user.location,
  theme: state => state.user.theme,
  isTemplateMode: state => state.user.mode === "template"
}
export default getters
